import { ComfeSettings, TaxpayerDetails } from '../types'
import { getPaymentRegion } from './regionHelpers'

export const shouldShowAddTaxId = (
  hasBilling: boolean,
  taxpayerDetails: TaxpayerDetails | null,
  comfeSettings: ComfeSettings | null,
  countryCode: string,
  onlyRequired = false
): boolean => {
  if (!hasBilling) return false

  if (taxpayerDetails?.taxId || taxpayerDetails?.nonProfitTaxId) return false

  if (!comfeSettings?.billingAccountTypeFields) return false

  const hasTaxField = (fieldList: string[] | undefined): boolean => {
    return (
      fieldList?.some(
        (field) =>
          field === 'taxId' ||
          field === 'nonProfitTaxId' ||
          field === 'taxIdOrNonProfitTaxId'
      ) || false
    )
  }

  // Check both consumer and business account types for any tax fields
  const consumerFields = comfeSettings.billingAccountTypeFields.consumer
  const businessFields = comfeSettings.billingAccountTypeFields.business

  const hasConsumerTaxFields =
    hasTaxField(consumerFields?.required) ||
    (!onlyRequired && hasTaxField(consumerFields?.optional))

  const hasBusinessTaxFields =
    hasTaxField(businessFields?.required) ||
    (!onlyRequired && hasTaxField(businessFields?.optional))

  // If neither account type has tax fields, return false
  if (!hasConsumerTaxFields && !hasBusinessTaxFields) return false

  if (!countryCode) return false

  const paymentRegion = getPaymentRegion(countryCode)
  return paymentRegion === 'AMS_PGS' || paymentRegion === 'EMEA_PGS'
}
